import { forwardRef, type ElementType, type HTMLAttributes, type Ref } from "react";
import styled from "@emotion/styled";

export type BoxProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
};

/* Box carried no Tailwind utilities pre-migration — it is a bare polymorphic
 * element. The styled root only contributes the Agentic label; `as` swaps the
 * rendered tag (excluded from shouldForwardProp so Emotion consumes it). */

const BoxRoot = styled("div", {
  label: "AgenticBox-root",
  shouldForwardProp: (propName) => propName !== "as"
})<{ as?: ElementType }>({});

export const Box = forwardRef<HTMLElement, BoxProps>(({ as: Component = "div", className, ...props }, ref) => (
  <BoxRoot as={Component} ref={ref as Ref<HTMLDivElement>} className={className} {...props} />
));

Box.displayName = "Box";
